/**
 * ONDATA 2 P6c — client API housekeeping.
 *
 * Usato dal bottone 'Marca pulita' del RoomDetailDrawer: lookup del task
 * della camera (GET /housekeeping/tasks) → POST /tasks/:id/done, che lato
 * server transita la camera dirty→free (housekeeping.ts). Fallback admin:
 * PATCH /rooms/:id {status:'free'} per camere dirty storiche senza task
 * (create prima che il checkout generasse il task post_checkout).
 *
 * NB: le route /housekeeping richiedono ruolo housekeeping/admin — il
 * bottone in UI e' gia' disabilitato per gli altri ruoli.
 */
import { api } from './client.js';

export type HousekeepingTaskDto = {
  id: string;
  roomId: string;
  roomCode: string;
  status: 'pending' | 'in_progress' | 'done' | 'skipped';
  kind: 'post_checkout' | 'mid_stay' | 'manual';
  priority: number;
  note: string | null;
  nextArrivalAt: string | null;
  nextGuestName: string | null;
  startedAt: string | null;
  completedAt: string | null;
  createdAt: string;
};

export async function fetchHousekeepingTasks(): Promise<{ tasks: HousekeepingTaskDto[] }> {
  return api('/housekeeping/tasks');
}

export async function markHousekeepingTaskDone(
  taskId: string,
): Promise<{ task: Record<string, unknown>; room: Record<string, unknown> }> {
  return api(`/housekeeping/tasks/${taskId}/done`, { method: 'POST' });
}

/** Fallback SOLO admin: forza la camera a 'free' via PATCH /rooms/:id. */
export async function adminSetRoomFree(roomId: string): Promise<{ room: Record<string, unknown> }> {
  return api(`/rooms/${roomId}`, {
    method: 'PATCH',
    body: JSON.stringify({ status: 'free' }),
  });
}
